import {
 Box,
 Button,
 FormControlLabel,
 Switch,
 TextField,
 Typography,
} from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import QRCodeSVG from 'react-qr-code';
import { TwoFactorSectionProps } from './types';

const TwoFactorSection: React.FC<TwoFactorSectionProps> = ({
 control,
 twoFactorEnabled,
 qrCode,
 loading,
 onGenerateQR,
 onTwoFactorChange,
 setQrCode,
}) => {
 const { t } = useTranslation();
 return (
  <Box
   sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pt: 2,
    borderTop: 1,
    borderTopColor: (th) => th.palette.kemek.lightestGray,
   }}
  >
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     gap: 2,
    }}
   >
    <Controller
     name="twoFactorEnabled"
     control={control}
     render={({ field }) => (
      <FormControlLabel
       control={
        <Switch
         checked={field.value}
         onChange={(e) => {
          const newValue = e.target.checked;
          field.onChange(newValue);
          onTwoFactorChange(newValue);
          if (!newValue) {
           setQrCode(null);
          }
         }}
         color="primary"
        />
       }
       label={t('user.twoFactor.title')}
       sx={{ m: 0 }}
      />
     )}
    />
    {!qrCode && (
     <Button
      variant="outlined"
      onClick={onGenerateQR}
      disabled={!twoFactorEnabled || loading?.identitySetTotp === true}
      size="medium"
      sx={{ display: 'flex', width: '100%', minHeight: 44 }}
     >
      {t('user.buttons.generateQR')}
     </Button>
    )}
    {qrCode && (
     <Box sx={{}}>
      <Box
       sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '48px',
        p: '12px',
        backgroundColor: (th) => th.palette.kemek.lightBlue,
       }}
      >
       <Box
        sx={{
         display: 'flex',
         flexDirection: 'column',
         gap: '12px',
        }}
       >
        <Typography sx={{ fontSize: 16 }}>
         {t('user.twoFactor.qrCode')}
        </Typography>
        <Typography sx={{ fontSize: 12 }}>
         {t('user.twoFactor.qrCodeDescription')}
        </Typography>
       </Box>
       <QRCodeSVG
        value={qrCode}
        size={256}
        style={{ maxWidth: '100%', height: 'auto' }}
       />
      </Box>
     </Box>
    )}
   </Box>
  </Box>
 );
};

export default TwoFactorSection;

